import type { FilaEstado, TablaConfig } from '../types/api';
import { minutosDesde } from './formato';

export type Situacion = 'error' | 'carga' | 'retraso' | 'ok' | 'inactiva' | 'pendiente' | 'sin_datos';

export const ETIQUETA: Record<Situacion, string> = {
  error: 'Error',
  carga: 'Carga inicial',
  retraso: 'Con retraso',
  ok: 'Al día',
  inactiva: 'Inactiva',
  pendiente: 'Sin preparar',
  sin_datos: 'Sin datos',
};

/**
 * Cómo está una tabla según lo último que mandó Airflow.
 * «Con retraso» = las altas llevan más del doble de su frecuencia (y 30 min de margen) sin pasar.
 */
export function situacion(t: TablaConfig, e: FilaEstado | undefined, ahora: Date = new Date()): Situacion {
  if (!t.activa) return 'inactiva';
  if (!e) return 'sin_datos';
  if (e.ult_error) return 'error';
  if (e.carga_en_curso) return 'carga';
  if (!e.preparada) return 'pendiente';
  const min = minutosDesde(e.ult_altas, ahora);
  if (min === null || min > 2 * t.frecuencia + 30) return 'retraso';
  return 'ok';
}
